import { PRODUCTION_MOCKUP_STATUSES } from 'swag-common/constants/order-statuses.constants';
export const getMockupToReview = productionMockups => {
  return productionMockups.find(currentMockup => currentMockup.status === PRODUCTION_MOCKUP_STATUSES.PENDING_CUSTOMER_APPROVAL);
};